export default __webpack_public_path__ + "static/media/02.2bb161b3.png";